import { BROKER_LINKS } from '@/data/brokers';

export default function AppEnding() {
  return (
    <>
      {/* Status bar */}
      <div className="fixed bottom-0 left-0 right-0 z-50 flex h-[30px] items-center justify-between bg-[#0F172A] px-4 md:px-6 text-white">
        <div className="flex items-center gap-4 font-mono text-[11px]">
          <span className="flex items-center gap-1.5">
            <span className="w-1.5 h-1.5 rounded-full bg-emerald-400"></span>
            Trạng thái: Máy chủ Forex Đang chạy
          </span>
          <span className="hidden sm:inline text-slate-400">Ping: 12ms</span>
        </div>
        <a
          href={BROKER_LINKS['XM']}
          target="_blank"
          rel="noopener noreferrer"
          className="whitespace-nowrap font-mono text-[11px] font-semibold text-violet-400 transition-colors hover:text-violet-300"
        >
          Mở Tài khoản Giao dịch →
        </a>
      </div>
    </>
  );
}
